export default __webpack_public_path__ + "static/media/mist_veiled_gold_elixir.8271834c.png";